// ════════════════════════════════════════════════════════════
// PWAUpdatePrompt — ECR
// ════════════════════════════════════════════════════════════
// Bandeau "Nouvelle version disponible — Recharger".
// Évite le piège du cache PWA : avant on était en 'autoUpdate'
// silencieux → la page ouverte continuait sur du vieux code et
// pouvait planter (chunks périmés). Ici on DÉTECTE la nouvelle
// version (poll 60s) et on laisse l'user recharger quand il veut.
// ════════════════════════════════════════════════════════════
import { useRegisterSW } from 'virtual:pwa-register/react';

// Intervalle de vérification d'une nouvelle version tant que l'app est ouverte.
const UPDATE_CHECK_INTERVAL_MS = 60_000;

export function PWAUpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_swUrl, registration) {
      if (!registration) return;
      setInterval(() => {
        void registration.update();
      }, UPDATE_CHECK_INTERVAL_MS);
    },
  });

  if (!needRefresh) return null;

  return (
    <div className="border-border bg-card fixed inset-x-3 bottom-20 z-50 mx-auto flex max-w-md items-center gap-3 rounded-xl border p-3 shadow-lg lg:bottom-6">
      <div className="min-w-0 flex-1">
        <p className="text-foreground text-sm font-semibold">Nouvelle version disponible</p>
        <p className="text-muted-foreground text-xs">Recharge pour appliquer la mise à jour.</p>
      </div>
      <button
        type="button"
        onClick={() => void updateServiceWorker(true)}
        className="bg-primary text-primary-foreground shrink-0 rounded-lg px-3 py-1.5 text-sm font-medium"
      >
        Recharger
      </button>
      <button
        type="button"
        onClick={() => {
          setNeedRefresh(false);
        }}
        className="text-muted-foreground hover:text-foreground shrink-0 rounded-lg px-2 py-1.5 text-sm"
      >
        Plus tard
      </button>
    </div>
  );
}
